define('view/finder/person.finder.view',['require','exports','module','underscore','./base.finder.view','fukit','model/person.model','model/contact.model','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                       = require('underscore'),
      BaseFinderView          = require('./base.finder.view'),
      ResourceQueryCollection = require('fukit').ResourceQueryCollection,
      PersonModel             = require('model/person.model'),
      ContactModel            = require('model/contact.model'),
      Formatter               = require('fukit').Formatter;

  var PersonFinderView = BaseFinderView.extend({
    options: function() {
      return _.extend({}, BaseFinderView.prototype.options, {
        searchCollectionClass: PersonModel.PersonDetailModel.Collection.extend({
          sort: {
            field: 'fullName',
          },
        }),
        searchFields: [
          {
            displayName: 'Name',
            name: 'fullName',
            useDistinctAutocompleteValues: true,
          },
          {
            displayName: 'Email',
            name: 'email',
            useDistinctAutocompleteValues: true,
          },
          {
            displayName: 'Phone',
            name: 'phone',
            useDistinctAutocompleteValues: true,
          },
        ],
        canShowPeopleWithoutAccount: true,
      });
    },

    internalViewOptions: BaseFinderView.extendInternalViewOptions({
      searchTableView: function() {
        return {
          columns: [
            { text: 'Name', data: 'fullName', formatter: Formatter.empty() },
            { text: 'Email', data: 'email', formatter: Formatter.empty() },
            { text: 'Phone', data: 'phone', formatter: Formatter.empty() },
          ],
        };
      },
      selectedTableView: function() {
        return {
          columns: [
            { text: 'Name', data: 'fullName', formatter: Formatter.empty() },
            { text: 'Email', data: 'email', formatter: Formatter.empty() },
            { text: 'Phone', data: 'phone', formatter: Formatter.empty() },
          ],
        };
      },
    }),

    getSearchFilters: function() {
      var filters = BaseFinderView.prototype.getSearchFilters.apply(this, arguments);
      if (!this.getOption('canShowPeopleWithoutAccount')) {
        filters.push({
          field: 'userAccountId',
          operation: '^',
          value: 'null',
          hidden: true,
        });
      }
      return filters;
    },
  });

  module.exports = PersonFinderView;
});

